export default {
  overFlowMenu: {
    tooltip: 'Weitere Funktionen',
    export: 'Benutzerdefinierte Bedeutungen exportieren',
    import: 'Benutzerdefinierte Bedeutungen importieren',
  },
};
